import React, { useEffect, useState, useRef } from "react"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faPlus, faSearch, faArrowLeft, faTimes  } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, Link } from "react-router-dom";  
import axios from "axios"; // Import Axios
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl"; // Ensure BASE_URL is defined
import img1 from "../Component/img/blog.webp";

const SearchDropdown = ({ selectedForms, eventUniqueId, type }) => {
 

  const navigate = useNavigate(); // To navigate between pages
  const [query, setQuery] = useState(""); // State for the search query
  const [results, setResults] = useState([]); // State for search results
  const [isLoading, setIsLoading] = useState(false); // Loading indicator
  const [debouncedQuery, setDebouncedQuery] = useState(query); // For debounce effect
  const debounceTimeout = useRef(null); // Ref to store debounce timeout



   const [isDropdownOpen, setDropdownOpen] = useState(false);
 
   const handleSearchClick = () => {
     setDropdownOpen(true);
   };
 
   const handleOutsideClick = (e) => {
     if (!e.target.closest(".search-container")) {
       setDropdownOpen(false);
     }
   };
 
   // Add event listener to close dropdown when clicking outside
   useEffect(() => {
     document.addEventListener("click", handleOutsideClick);
     return () => document.removeEventListener("click", handleOutsideClick);
   }, []);
 

   useEffect(() => {
    if (debouncedQuery.trim().length === 0) {
      setResults([]); // Clear results if query is empty
      return;
    }

    setIsLoading(true); // Show loading indicator

    const fetchResults = async () => {
      try {
        console.log("Sending data to API:", { query: debouncedQuery });
        const response = await axios.post(`${BASE_URL}/search`, { query: debouncedQuery });
        console.log("API response:", response.data);
        setResults(response.data.data || []); // Update results state with the data field
      } catch (error) {
        console.error("Error fetching search results:", error);
      } finally {
        setIsLoading(false); // Hide loading indicator
      }
    };

    fetchResults();
  }, [debouncedQuery]); // Only re-run the effect when the debounced query changes

  const handleSearchChange = (e) => {
    const searchQuery = e.target.value;
    setQuery(searchQuery); // Update the query state

    // Clear the previous debounce timeout
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // Set a new debounce timeout
    debounceTimeout.current = setTimeout(() => {
      setDebouncedQuery(searchQuery); // Update the debounced query
    }, 500); // Wait 500ms after the user stops typing
  };

  const highlightText = (text) => {
    if (!query) return text; // Return original text if no query
    const regex = new RegExp(`(${query})`, 'gi'); // Create a case-insensitive regex to match the query
    return text.split(regex).map((part, index) =>
      regex.test(part) ? <strong key={index}>{part}</strong> : part
    );
  };




  return (
    <div className="position-relative w-75 m-left hide-on-mobile search-container">
          <span className="position-absolute top-50 translate-middle-y ms-2">
            <FontAwesomeIcon icon={faSearch} className="text-muted" />
          </span>
          <input
            type="text"
            style={{ padding: "0px 0px 0px 30px" }}
            className="inputsearch w-100"
            placeholder="Search By Event Name, Location..."
            onClick={handleSearchClick}
            value={query}
                onChange={handleSearchChange} 
          />
    
          {isDropdownOpen && (
            <div className="search-dropdown">
              {/* Search Results */}
              <div className="container mt-4">
              <div className="row text-start">
            {isLoading ? (
              <div className="col-12 text-center">
                {/* Spinner Loader */}
                <div className="d-flex justify-content-center align-items-center">
                  <span className="loader"></span>
                  <p className="ms-3">Loading Content...</p>
                </div>
              </div>
            ) : results.length > 0 ? (
              results.map((result, index) => (
                <div key={index} className="col-md-4 mb-3">
                  <div className="d-flex">
                    {/* Event Banner */}
                    <div>
                      <img
                        src={
                          result.keyword === "exhibition"
                            ? `${IMAGE_URL}/eventFiles/${result.eventbanner}`
                            : `${IMAGE_URL}/conferenceFiles/${result.eventbanner}`
                        }
                        alt={result.exhibition_name || result.conference_name}
                        className="img-fluid rounded"
                        style={{ maxHeight: "50px" }}
                        onError={(e) => (e.target.src = img1)} // Fallback image
                      />
                    </div>

                    {/* Event Details */}
                    <div className="ms-3">
                      <p className="hda1">
                        <Link
                          to={
                            result.keyword === "exhibition"
                              ? `/exhibition/${result.exhibition_slug}`
                              : `/conference/${result.conference_slug}`
                          }
                        >
                          {result.keyword === "exhibition"
                            ? highlightText(result.exhibition_name)
                            : highlightText(result.conference_name)}
                        </Link>
                      </p>
                      <div>
                        <span className="text-muted ft13">
                          {result.keyword === "exhibition" ? `Exhibition` : `Conference`}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">No results found</div>
            )}
          </div>
              </div>
          
            </div>
          )}
    
          <style jsx>{`
            .search-dropdown {
              position: absolute;
              width: 100vw; /* Half of the viewport width */
              left: 0;
              background: white;
              box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
              padding: 10px;
              border-radius: 5px;
              z-index: 1000;
              top: 100%; /* Below the input field */
              transform: translateX(-14%);
            }
            .search-dropdown ul {
              list-style: none;
              padding: 0;
              margin: 0;
            }
            .search-dropdown li {
              padding: 10px;
              border-bottom: 1px solid #eee;
              cursor: pointer;
            }
            .search-dropdown li:hover {
              background: #f8f8f8;
            }
          `}</style>
        </div>
  );
};

export default SearchDropdown;
